/**
 * Single header ticker editable block component
 */

import IconSelector from "./IconSelector";

class EditableHeaderTickerBlock {
  /**
   * EditableHeaderTickerBlock component constructor
   * @param {HTMLElement} domElement
   */
  constructor(domElement = null) {
    this.container = $(domElement);

    this.previewIcon = this.container.find(".selected-icon");

    this.toggleBtn = this.container.find(".toggle-icon-modal-button");
    this.removeBtn = this.container.find(".remove-icon-button");

    this.IconSelector = new IconSelector({});
    this.iconHiddenInput = this.container.find(".icon-hidden-input");

    this.setEventListeners();
  }

  /**
   * Destructor method
   */
  destroy() {
    this.removeEventListeners();
  }

  /**
   * Attach event listeners
   */
  setEventListeners() {
    this.IconSelector.on("onSelect", ({ data }) =>
      this.handleIconSelection(data)
    );

    this.container.on("click touch", `.toggle-icon-modal-button`, (event) =>
      this.showIconModal(event)
    );
    this.container.on("click touch", `.remove-icon-button`, (event) =>
      this.removeIcon(event)
    );
  }

  /**
   * Remove attached event listeners
   */
  removeEventListeners() {
    this.container.off();
  }

  /**
   * Show selection modal
   */
  showIconModal() {
    const currentIcon = this.iconHiddenInput
      .html()
      .replace(/(?:&nbsp;|<br>)/g, "");
    this.IconSelector.show(currentIcon);
  }

  /**
   * Handler for Icon select action
   * @param {Object} iconData
   */
  async handleIconSelection(iconData = {}) {
    try {
      if (this.iconHiddenInput.html() == "") {
        this.iconChangeAdjustBtns("added");
      }
      // Set value to hidden EXT.js input
      const { iconPath } = iconData;
      this.iconHiddenInput.html(iconPath);

      // Fetch icon svg content (for preview only)
      const response = await $.ajax({
        url: iconPath,
        dataType: "html",
        type: "GET",
      });

      // Set icon
      this.setIconPreview(response);
    } catch (err) {
      throw err;
    }
  }

  /**
   * Set icon preview
   * @param {String} iconContent
   */
  setIconPreview(iconContent = "") {
    const currentIcon = this.previewIcon.find("svg");
    if (currentIcon.length > 0) {
      currentIcon.remove();
    }

    if (iconContent) {
      this.previewIcon.addClass("btn-icon");
      this.previewIcon.prepend(iconContent);
    } else {
      this.previewIcon.removeClass("btn-icon");
    }
  }

  /**
   * Remove icon action
   */
  removeIcon() {
    this.iconHiddenInput.html("");

    this.setIconPreview(null);

    this.iconChangeAdjustBtns("removed");
  }

  /**
   * Adjust visible buttons and text dynamically depending on the action 
   * @param {String} action
   */
  iconChangeAdjustBtns(action) {
    if (action == "removed") {
      this.removeBtn.addClass("d-none");
      this.toggleBtn
        .find(".toggle-btn-text")
        .text(this.toggleBtn.data("add-text"));
    }

    if (action == "added") {
      this.removeBtn.removeClass("d-none");
      this.toggleBtn
        .find(".toggle-btn-text")
        .text(this.toggleBtn.data("change-text"));
    }
  }
}

export default EditableHeaderTickerBlock;
